export default class Accordion {
  constructor(gallery) {
    const list = gallery.querySelector('.u-mosaic-gallery__list');
    jQuery(list).justifiedGallery({
      margins: 5,
    });
  }
}
